import * as React from 'react';
import {
  RootContext,
  AbstractForm,
  MnInputText,
  MnInputTextarea,
  MnInputRadioGroup,
  PatientHealthConditionValidators,
  PatientHealthConditionCurrentStates,
  PatientHealthConditionWalkingStates,
  PatientHealthConditionMetalsStates,
  PatientHealthConditionInfectionStates,
  PatientHealthConditionInfectionTypeStates,
  PatientHealthConditionDrugAllergyStates,
  PatientHealthConditionRenalDysfunctionStates,
} from '../../../index';

export default class PatientHealthConditionForm extends AbstractForm {
  static contextType = RootContext;

  constructor (props) {
    super(props);
    this.state = { detailVisibility: {} };
  }

  render () {
    const { t } = this.context;

    const onChangeRadioButtonWithDetail = (e) => {
      this.props.onChange(e);
      // 可視状態の切り替え
      const currentVisibility = this.state.detailVisibility;
      currentVisibility[e.name] = (e.value === 'present');
      this.setState({ detailVisibility: currentVisibility });
      // 入力されている値の削除
      const regex = new RegExp(e.name + '_.*', 'g');
      Object.keys(this.props.patientHealthCondition)
        .filter(function (value) { return value.match(regex); })
        .forEach(filteredKey => {
          this.props.patientHealthCondition[filteredKey] = null;
        });
    };

    return (
      <div className="p-interview--content mb-lg">
        <h5 className="fz-xl lh-sm fw-br">{t('Treatment.patient_health_condition_title')}</h5>
        <div>
          <p>{t('Treatment.patient_health_condition.current_state')}<span className="required">{t('Treatment.required')}</span></p>
          <div>
            <MnInputRadioGroup
              name="current_state"
              value={ this.props.patientHealthCondition.current_state }
              groups={ PatientHealthConditionCurrentStates }
              errors={ this.props.annotation.current_state }
              onChange={ this.props.onChange }
              onValidate={ this.props.onValidate }
              required={ this.props.requiredMessage }
              class={'c-mn-radio-btn--col1'}
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.illness_name')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputText
              id="patient_health_condition_illness_name"
              name="illness_name"
              value={ this.props.patientHealthCondition.illness_name }
              placeholder={t('Treatment.patient_health_condition.illness_name')}
              errors={ this.props.annotation.illness_name }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.illness_name_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.medical_history')}</p>
          <div className="d-fx">
            <MnInputText
              id="patient_health_condition_medical_history"
              name="medical_history"
              value={ this.props.patientHealthCondition.medical_history }
              placeholder={t('Treatment.patient_health_condition.medical_history')}
              errors={ this.props.annotation.medical_history }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.medical_history_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.current_course')}<span className="required">{t('Treatment.required')}</span></p>
          <div className="d-fx">
            <MnInputTextarea
              id="patient_health_condition_current_course"
              name="current_course"
              value={ this.props.patientHealthCondition.current_course }
              placeholder={t('Treatment.patient_health_condition.current_course')}
              errors={ this.props.annotation.current_course }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.current_course_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              rows={4}
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.height')}</p>
          <div className="d-fx">
            <MnInputText
              id="patient_health_condition_height"
              name="height"
              value={ this.props.patientHealthCondition.height }
              placeholder={t('Treatment.patient_health_condition.height')}
              errors={ this.props.annotation.height }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.height_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              t={t}
            />
            <div className="d-fx pt-lg">cm</div>
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.weight')}</p>
          <div className="d-fx">
            <MnInputText
              id="patient_health_condition_weight"
              name="weight"
              value={ this.props.patientHealthCondition.weight }
              placeholder={t('Treatment.patient_health_condition.weight')}
              errors={ this.props.annotation.weight }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.weight_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              t={t}
            />
            <div className="d-fx pt-lg">kg</div>
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.walking_state')}</p>
          <div className="d-fx">
            <MnInputRadioGroup
              name="walking_state"
              value={ this.props.patientHealthCondition.walking_state }
              groups={ PatientHealthConditionWalkingStates }
              errors={ this.props.annotation.walking_state }
              onChange={ this.props.onChange }
              onValidate={ this.props.onValidate }
              t={t}
            />
          </div>
        </div>
        <div>
          <p>{t('Treatment.patient_health_condition.metals')}</p>
          <div className="d-fx">
            <MnInputRadioGroup
              name="metals"
              value={ this.props.patientHealthCondition.metals }
              groups={ PatientHealthConditionMetalsStates }
              errors={ this.props.annotation.metals }
              onChange={ onChangeRadioButtonWithDetail }
              onValidate={ this.props.onValidate }
              t={t}
            />
          </div>
        </div>
        {
          this.state.detailVisibility.metals ? (
            <div>
              <MnInputText
                id="patient_health_condition_metals_detail"
                name="metals_detail"
                value={ this.props.patientHealthCondition.metals_detail }
                placeholder={t('Treatment.patient_health_condition.metals_detail')}
                errors={ this.props.annotation.metals_detail }
                onValidate={ this.props.onValidate }
                validates={ PatientHealthConditionValidators.metals_detail_i18n }
                onChange={ this.props.onChange }
                onDestroy={ this.onRemoveValidate }
                t={t}
              />
            </div>
          ) : null
        }
        <div>
          <p>{t('Treatment.patient_health_condition.infection')}</p>
          <div className="d-fx">
            <MnInputRadioGroup
              name="infection"
              value={ this.props.patientHealthCondition.infection }
              groups={ PatientHealthConditionInfectionStates }
              errors={ this.props.annotation.infection }
              onChange={ onChangeRadioButtonWithDetail }
              onValidate={ this.props.onValidate }
              t={t}
            />
          </div>
        </div>
        {
          this.state.detailVisibility.infection ? (
            <>
              <div>
                <MnInputRadioGroup
                  name="infection_type"
                  value={ this.props.patientHealthCondition.infection_type }
                  groups={ PatientHealthConditionInfectionTypeStates }
                  errors={ this.props.annotation.infection_type }
                  onChange={ this.props.onChange }
                  onValidate={ this.props.onValidate }
                  t={t}
                />
              </div>
              <div>
                <MnInputText
                  id="patient_health_condition_infection_detail"
                  name="infection_detail"
                  value={ this.props.patientHealthCondition.infection_detail }
                  placeholder={t('Treatment.patient_health_condition.infection_detail')}
                  errors={ this.props.annotation.infection_detail }
                  onValidate={ this.props.onValidate }
                  validates={ PatientHealthConditionValidators.infection_detail_i18n }
                  onChange={ this.props.onChange }
                  onDestroy={ this.onRemoveValidate }
                  t={t}
                />
              </div>
            </>
          ) : null
        }
        <div>
          <p>{t('Treatment.patient_health_condition.renal_dysfunction')}</p>
          <div className="d-fx">
            <MnInputRadioGroup
              name="renal_dysfunction"
              value={ this.props.patientHealthCondition.renal_dysfunction }
              groups={ PatientHealthConditionRenalDysfunctionStates }
              errors={ this.props.annotation.renal_dysfunction }
              onChange={ onChangeRadioButtonWithDetail }
              onValidate={ this.props.onValidate }
              t={t}
            />
          </div>
        </div>
        {
          this.state.detailVisibility.renal_dysfunction ? (
            <div>
              <MnInputText
                id="patient_health_condition_renal_dysfunction_detail"
                name="renal_dysfunction_detail"
                value={ this.props.patientHealthCondition.renal_dysfunction_detail }
                placeholder={t('Treatment.patient_health_condition.renal_dysfunction_detail')}
                errors={ this.props.annotation.renal_dysfunction_detail }
                onValidate={ this.props.onValidate }
                validates={ PatientHealthConditionValidators.renal_dysfunction_detail_i18n }
                onChange={ this.props.onChange }
                onDestroy={ this.onRemoveValidate }
                t={t}
              />
            </div>
          ) : null
        }
        <div>
          <p>{t('Treatment.patient_health_condition.drug_allergy')}</p>
          <div className="d-fx">
            <MnInputRadioGroup
              name="drug_allergy"
              value={ this.props.patientHealthCondition.drug_allergy }
              groups={ PatientHealthConditionDrugAllergyStates }
              errors={ this.props.annotation.drug_allergy }
              onChange={ onChangeRadioButtonWithDetail }
              onValidate={ this.props.onValidate }
              t={t}
            />
          </div>
        </div>
        {
          this.state.detailVisibility.drug_allergy ? (
            <div>
              <MnInputText
                id="patient_health_condition_drug_allergy_detail"
                name="drug_allergy_detail"
                value={ this.props.patientHealthCondition.drug_allergy_detail }
                placeholder={t('Treatment.patient_health_condition.drug_allergy_detail')}
                errors={ this.props.annotation.drug_allergy_detail }
                onValidate={ this.props.onValidate }
                validates={ PatientHealthConditionValidators.drug_allergy_detail_i18n }
                onChange={ this.props.onChange }
                onDestroy={ this.onRemoveValidate }
                t={t}
              />
            </div>
          ) : null
        }
        <div>
          <p>{t('Treatment.patient_health_condition.etc')}</p>
          <div className="d-fx">
            <MnInputTextarea
              id="patient_health_condition_etc"
              name="etc"
              value={ this.props.patientHealthCondition.etc }
              placeholder={t('Treatment.patient_health_condition.etc')}
              errors={ this.props.annotation.etc }
              onValidate={ this.props.onValidate }
              validates={ PatientHealthConditionValidators.etc_i18n }
              onChange={ this.props.onChange }
              onDestroy={ this.onRemoveValidate }
              rows={4}
              t={t}
            />
          </div>
        </div>
      </div>
    );
  }
}
